/* app/js/src/components/external-mam/external-mam-gateway-playground/search-grid-components/external-mam-search-results-name-cell/external-mam-search-results-name-cell.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  bottom: 4px;
}
span {
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
/*# sourceMappingURL=external-mam-search-results-name-cell.component.css.map */
